import { render } from "./ProgramAttendeesView.vue?vue&type=template&id=11368c3e"
import script from "./ProgramAttendeesView.vue?vue&type=script&lang=js"
export * from "./ProgramAttendeesView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__